import { useMemo, useContext } from 'react';
import { differenceInSeconds } from 'date-fns';

// Import components
import { PlayerElements as Player } from 'components/elements';
import { ShakaPlayerTvContext } from 'components/context/player/player_tv/ShakaPlayerTvProvider';

// Import hooks
import { useAppSelector } from 'store/hooks';

// Import styles
import { StyledButton } from './styles';

const RestartController = () => {
	const { isFocus, updateTime, player } = useContext(ShakaPlayerTvContext);
	const channel_uuid = useAppSelector(({ program_details }) => program_details.data.channel_uuid);
	const channelID = useAppSelector(({ selected_program }) => selected_program.channelID);
	const lives = useAppSelector(({ channels }) => channels.data.lives);

	const UUID = channel_uuid || channelID;
	const live = lives.find(({ uuid }) => uuid === UUID);

	const epgProgrammes = live?.epgProgrammes || [];
	const currentLiveIndex = live?.currentLiveIndex || 0;
	const epgProgram = epgProgrammes[currentLiveIndex];
	const since = epgProgram?.since || '';

	const programBeginTime = useMemo(() => {
		const startTime = player.getPresentationStartTimeAsDate();
		return differenceInSeconds(new Date(since), startTime);
		// eslint-disable-next-line
	}, [since]);

	const handleRestart = () => updateTime(programBeginTime);

	if (!live) return null;

	return (
		<StyledButton modifiers={['icon', 'playerIconHover']} onClick={handleRestart} isFocus={isFocus}>
			<Player.IconPrevious />
		</StyledButton>
	);
};

export default RestartController;
